import type { Blocker } from 'react-router-dom'

export interface BlockerRegistration {
  id: string
  blocker: Blocker
  type?: 'note' | 'navigation' | 'other'
}

class BlockerManager {
  private static instance: BlockerManager
  private blockers: Map<string, BlockerRegistration> = new Map()

  private constructor() {}

  static getInstance(): BlockerManager {
    if (!BlockerManager.instance) {
      BlockerManager.instance = new BlockerManager()
    }
    return BlockerManager.instance
  }

  registerBlocker(
    id: string,
    blocker: Blocker,
    type?: BlockerRegistration['type'],
  ): void {
    if (this.blockers.has(id)) {
      console.warn(
        `[BlockerManager] Blocker with id "${id}" already registered. Overwriting.`,
      )
    }

    this.blockers.set(id, { id, blocker, type })
  }

  unregisterBlocker(id: string): void {
    this.blockers.delete(id)
  }

  resetAllBlockers(): void {
    this.blockers.forEach(({ blocker, id }) => {
      try {
        if (blocker.state === 'blocked') {
          blocker.reset()
        }
      } catch (error) {
        console.error(
          `[BlockerManager] Error resetting blocker "${id}":`,
          error,
        )
      }
    })
  }

  disableNoteBlockers(): void {
    this.blockers.forEach(({ blocker, id, type }) => {
      if (type === 'note') {
        try {
          if (blocker.state === 'blocked') {
            blocker.reset()
          }
        } catch (error) {
          console.error(
            `[BlockerManager] Error disabling note blocker "${id}":`,
            error,
          )
        }
      }
    })
  }

  getBlockerCount(): number {
    return this.blockers.size
  }

  getBlockerIds(): string[] {
    return Array.from(this.blockers.keys())
  }

  clear(): void {
    this.blockers.clear()
  }
}

export const blockerManager = BlockerManager.getInstance()
